import modelNames from '@/ts/index';
import JsonModels from '@/ts/models.json';

export interface ColumnDefinition {
    field: string;
    header: string;
    sortable: boolean;
    filter: boolean;
    dataType: string;
    enabled: boolean;
    isProhibited?: boolean;
    isUnique?: boolean;
    isFilled?: boolean;
}

/** Config for filter rule controls that use a searchable multi-select (e.g. party IDs). */
export interface FilterControlConfig {
    /** Slug used to look up options source and accessors in the filter control registry (e.g. 'raw_ddex_parties'). */
    optionsSource: string;
    /** Placeholder for the combobox (optional; can be overridden per column). */
    placeholder?: string;
}

export interface JsonModel {
    _columnNameMappings?: Record<string, string>;
    _filterFieldMappings?: Record<string, string>;
    _filterArrayMappings?: Record<string, string>;
    _prohibited?: string[];
    _filled?: string[];
    _unique?: string[];
    _displayName?: string;
    _slug?: string;
    [key: string]: any;
}

export function isModelDataType(dataType: string): boolean {
    return dataType in modelNames;
}

export function isModelArrayDataType(dataType: string): boolean {
    if (!dataType.endsWith('[]')) {
        return false;
    }
    const modelName = dataType.slice(0, -2); // Remove '[]' suffix
    return modelName in modelNames;
}

/**
 * Get the filter array slug for a given model and field name.
 * This looks up the _filterArrayMappings in models.json to find the slug
 * that should be used for querying the API endpoint.
 *
 * @param modelName - The model name (e.g., 'Bucket')
 * @param fieldName - The field name (e.g., 'bucket_genres')
 * @returns The slug string or null if not found
 */
export function getFilterArraySlug(modelName: string, fieldName: string): string | null {
    try {
        const model = JsonModels[modelName as keyof typeof JsonModels] as JsonModel | undefined;
        if (model && model._filterArrayMappings && model._filterArrayMappings[fieldName]) {
            return model._filterArrayMappings[fieldName];
        }
    } catch (error) {
        // If models.json is not available or there's an error, return null
        console.warn(`Could not get filter array slug for ${modelName}.${fieldName}:`, error);
    }
    return null;
}
